<template>
  <ul class="review-list" :class="'col'+column">
    <template v-for="review in reviews" v-bind:key="review">
      <ReviewCard
          title="강력 추천합니다"
          :content="review.content"
          :thumbnail="review.image"
          info="T-ZONE"
          :write-date-time="review.writeDateTime"
          :writer="review.writer.nickName"
      ></ReviewCard>
    </template>
  </ul>
</template>

<script>
import ReviewCard from "../components/ReviewCard";
import apiClient from "../../utils/instance";

export default {
  name: "ReviewCardList",
  props: ["column"],
  components: {ReviewCard},
  methods: {},
  data() {
    return {
      page: 0,
      reviews: []
    }
  },
  async mounted() {
    this.reviews = (await apiClient.instance.get('/reviews?page=' + this.page)).data
  }
}
</script>

<style>
/* review-list */
.col2 {
  grid-template-columns: repeat(2, 1fr);
}

.col3 {
  grid-template-columns: repeat(3, 1fr);
}

@media screen and (max-width: 767px) {
  .col2 {
    grid-template-columns: repeat(1, 1fr);
  }

  .col3 {
    grid-template-columns: repeat(1, 1fr);
  }
}

.review-list {
  display: grid;
  grid-gap: 15px;
  position: relative;
  left: -1.75%;;
  width: 103.5%;
  text-align: left;
}

.review-list li {
  padding: 15px 1.75%;
}

.review-list li .review-inner {
  border-radius: 16px;
  background: #39393d;
  padding: 40px 8% 26px;
  box-sizing: border-box;
}

.review-list li .tit {
  height: 56px;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.2;
  white-space: normal;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.review-list li .info {
  display: block;
  font-size: 12px;
  margin-top: 20px;
}

.review-list li .img-wrap {
  width: 100%;
  height: 237px;
  background: #c4c4c4;
  margin-top: 32px;
}

.review-list li .img-wrap img {
  Width: 100%;
  height: 100%;
  object-fit: cover;
}

.review-list li .tx-wrap {
  margin-top: 40px;
}

.review-list li .tx-wrap .name {
  font-size: 20px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.review-list li .tx-wrap .date {
  font-size: 12px;
  font-weight: normal;
  color: #909090;
  margin-top: 8px;
}

.review-list li .tx-wrap .tx-box {
  font-size: 16px;
  font-weight: normal;
  line-height: 1.8;
  -webkit-box-orient: vertical;
  margin-top: 16px;
  overflow: hidden;
}

.review-list li .btn-more {
  display: block;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  color: #53c4e3;
  border-bottom: 1px solid #53c4e3;
  margin-top: 8px;
}

</style>
